export const PRIMARY_COLOR = '#e26856';
export const SECONDARY_COLOR = '#8b1713';
export const PRIMARY_360_COLOR = '#59cd90';
export const SECONDARY_360_COLOR = '#1e6842';
export const PRIMARY_PRUZKUM_COLOR = '#3fa7d6';
